module.exports = __webpack_public_path__ + "media/buy_report_icons/info-9b1bf90f.svg";